// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.action-history-container .table-responsive {\n  max-height: 700px;\n  overflow-y: auto;\n}\n#actionHistory.table-striped tbody tr:nth-of-type(even) {\n  background-color: #f5f6f6 !important;\n}\n#actionHistory td {\n  border: none;\n}\n#actionHistory thead th {\n  border-top: 0;\n  border-bottom: 1px solid #e9ecef;\n}\n", ""]);
// Exports
module.exports = exports;
